// // src/context/CategoriesContext.jsx

// import { createContext, useContext, useEffect, useState } from 'react';
// import { fetchCategories } from '../api/categoriesApi';

// const CategoriesContext = createContext();

// export function CategoriesProvider({ children }) {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const load = async () => {
//       const data = await fetchCategories();
//       setCategories(data);
//       setLoading(false);
//     };
//     load();
//   }, []);

//   return (
//     <CategoriesContext.Provider value={{ categories, loading }}>
//       {children}
//     </CategoriesContext.Provider>
//   );
// }

// export function useCategories() {
//   const context = useContext(CategoriesContext);
//   if (!context) throw new Error('useCategories must be used within CategoriesProvider');
//   return context;
// }

// src/context/CategoriesContext.js

// import { createContext, useContext, useState, useEffect } from 'react';
// import { fetchCategories } from '../api/categoriesApi';

// const CategoriesContext = createContext();

// export function CategoriesProvider({ children }) {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const load = async () => {
//       const data = await fetchCategories();
//       setCategories(data);
//       setLoading(false);
//     };
//     load();
//   }, []);

//   return (
//     <CategoriesContext.Provider value={{ categories, loading }}>
//       {children}
//     </CategoriesContext.Provider>
//   );
// }

// export function useCategories() {
//   const context = useContext(CategoriesContext);
//   if (!context) throw new Error('useCategories must be used within CategoriesProvider');
//   return context;
// }

import { createContext, useContext, useState, useEffect } from "react";
import { fetchCategories } from "../api/categoriesApi";

const CategoriesContext = createContext();

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
       
        setLoading(true);
        setError(null);

        const rawData = await fetchCategories();

       

        if (!rawData) {
          console.error("No data received from fetchCategories");
          setCategories([]);
          setError("No data received from API");
          return;
        }

        if (!Array.isArray(rawData)) {
          console.error(
            "Expected array from fetchCategories, got:",
            typeof rawData
          );
          setCategories([]);
          setError("Invalid data format received");
          return;
        }

        if (rawData.length === 0) {
          console.warn("Empty array received from fetchCategories");
          setCategories([]);
          setError("No categories available");
          return;
        }

        // Validate and filter items
        const validItems = rawData.filter((item, index) => {
          const isValid =
            item &&
            typeof item === "object" &&
            typeof item.category === "string" &&
            Array.isArray(item.subcategories);

          if (!isValid && index < 3) {
            console.warn(`Invalid category at index ${index}:`, item);
          }

          return isValid;
        });

        setCategories(validItems); // Store validated data
     
      } catch (err) {
       
        setCategories([]);
        setError(err.message || "Failed to load categories");
      } finally {
        setLoading(false);
    
      }
    };

    load();
  }, []);

  // Debug current state
  useEffect(() => {
   
  }, [categories, loading, error]);

  const contextValue = {
    categories,
    loading,
    error,
    // Add a refresh function for debugging
    refresh: async () => {
      
      setLoading(true);
      const load = async () => {
        try {
          const rawData = await fetchCategories();
          if (!rawData || !Array.isArray(rawData)) {
            setCategories([]);
            setError("Invalid data format");
            return;
          }
          // Validate and filter items (same validation as initial load)
          const validItems = rawData.filter((item) => {
            return (
              item &&
              typeof item === "object" &&
              typeof item.category === "string" &&
              Array.isArray(item.subcategories)
            );
          });
          setCategories(validItems);
          setError(null);
        } catch (err) {
          console.error("Failed to refresh categories:", err);
          setError(err.message);
        } finally {
          setLoading(false);
        }
      };
      await load();
    },
  };

  return (
    <CategoriesContext.Provider value={contextValue}>
      {children}
    </CategoriesContext.Provider>
  );
}

export function useCategories() {
  const context = useContext(CategoriesContext);
  if (!context) {
    throw new Error("useCategories must be used within a CategoriesProvider");
  }
  return context;
}
